import React from "react";
import { IconProps } from "@chakra-ui/react";

export const withIconProps = (IconComponent: React.FC<IconProps>) => ({
  color,
  ...props
}: IconProps) => <IconComponent fill={color} {...props} />;
